var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let MapSpriteSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "name");
    __publicField(this, "flipHorizontal");
    __publicField(this, "flipVertical");
    __publicField(this, "visible");
    __publicField(this, "opacity");
  }
};
__decorateClass([
  type("string")
], MapSpriteSchema.prototype, "name", 2);
__decorateClass([
  type("boolean")
], MapSpriteSchema.prototype, "flipHorizontal", 2);
__decorateClass([
  type("boolean")
], MapSpriteSchema.prototype, "flipVertical", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], MapSpriteSchema.prototype, "visible", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], MapSpriteSchema.prototype, "opacity", 2);
MapSpriteSchema = __decorateClass([
  Component("MapSprite")
], MapSpriteSchema);
const __vite_glob_0_27 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get MapSpriteSchema() {
    return MapSpriteSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  MapSpriteSchema as M,
  __vite_glob_0_27 as _
};
//# sourceMappingURL=MapSprite-b447e6f3.js.map
